export const PAGE_VIEW = 'page_view'; // main page view override event
export const GTM_DATALAYER = 'gtm:datalayer';

export const JOIN_LOGIN_TRIGGERED = 'Join_Login (Triggered)'; // for use with Google One Tap

export const JOIN_TRIGGERED = 'Join (Triggered)';
export const JOIN_CLICK = 'Join (Click)';
export const JOIN_COMPLETE = 'Join (Complete)';

export const LOGIN_TRIGGERED = 'Login (Triggered)';
export const LOGIN_CLICK = 'Login (Click)';
export const LOGIN_COMPLETE = 'Login (Complete)';

export const SEARCH_MANUAL = 'Search-Manual (Click)';
export const SEARCH_AUTOSUGGEST = 'Search-Autosuggestion (Click)';
export const SEARCH_COMPLETE = 'Search-Return (Complete)';

export const EC_BEGIN_CHECKOUT = 'begin_checkout';
export const EC_PURCHASE_COMPLETE = 'purchase';
export const EC_PLAN_SELECTION = 'add_to_cart';
export const EC_VIEW_PLANS = 'view_item_list';

export const PURCHASE_CLICK = 'Purchase (Click)';
export const PURCHASE_COMPLETE = 'Purchase (Complete)';
export const PURCHASE_ERROR = 'Purchase (Error)';

export const EXPLORE_CLICK = 'Explore (Click)';
export const TRENDING_CLICK = 'Trending (Click)';
export const KEYWORD_CLICK = 'Keyword (Click)';

export const LOCALE_TRIGGERED = 'Locale (Triggered)';
export const LOCALE_CLICK = 'Locale (Click)';
export const LOCALE_COMPLETE = 'Locale (Complete)';

export const SOCIAL_SHARE_CLICK = 'Social_Share (Click)';
export const ZOOM_CLICK = 'Zoom (Click)';
export const FAVORITE_CLICK = 'Favorite (Click)';
export const EDITOR_CLICK = 'Editor (Click)';

export const JOIN_PRO_TRIGGERED = 'Join_Pro (Triggered)';
export const JOIN_PRO_CLICK = 'Join_Pro (Click)';
export const JOIN_PRO_COMPLETE = 'Join_Pro (Complete)';

export const TRIAL_UPGRADE_TRIGGERED = 'Trial-Upgrade (Triggered)';
export const TRIAL_UPGRADE_CLICK = 'Trial Upgrade (Click)';
export const TRIAL_UPGRADE_COMPLETE = 'Trial Upgrade (Complete)';

export const POPULAR_SEARCHES_CLICK = 'Popular_Searches (Click)';

export const LICENSING_CLICK = 'Licensing (Click)';
export const LICENSING_TRIGGERED = 'Licensing (Triggered)';
export const LICENSING_COMPLETE = 'Licensing (Complete)';

export const CONTRIBUTOR_CLICK = 'Contributor_Selection (Click)';
export const CONTRIBUTOR_FOLLOW = 'Contributor_Follow (Click)';

export const CONTENT_SELECTION_CLICK = 'Content_Selection (Click)';

export const DOWNLOAD_CLICK = 'Download (Click)';
export const DOWNLOAD_COMPLETE = 'Download (Complete)';

export const FILTERS_HIDE_CLICK = 'Filters-Hide (Click)';
export const FILTERS_APPLIED_CLICK = 'Filters-Applied (Click)';

export const PAGINATION_CLICK = 'Pagination (Click)';

export const COLLECTION_SAVE_CLICK = 'Collection-Save (Click)';
export const COLLECTION_SAVE_COMPLETE = 'Collection-Save (Complete)';
export const COLLECTION_REMOVE_CLICK = 'Collection-Remove (Click)';
export const COLLECTION_REMOVE_COMPLETE = 'Collection-Remove (Complete)';
export const COLLECTION_CREATED_COMPLETE = 'Collection-Created (Complete)';
export const COLLECTION_DELETED_COMPLETE = 'Collection-Deleted (Complete)';

export const FORM_FIELD_FOCUS = 'Form (Focus)';
export const FORM_COMPLETE = 'Form (Complete)';
export const FORM_ERROR = 'Form (Error)';

export const PARTNER_INFINITE_SCROLL_TRIGGERED = 'Partner-Infinite_Scroll (Triggered)';
export const PARTNER_INFINITE_SCROLL_CLICK = 'Partner-Infinite_Scroll (Click)';
export const PARTNER_GRAY_BOX_TRIGGERED = 'Partner-Gray_Box (Triggered)';
export const PARTNER_GRAY_BOX_CLICK = 'Partner-Gray_Box (Click)';
export const PARTNER_POPUP_TRIGGERED = 'Partner-Popup (Triggered)';

export const NOTIFICATIONS_CLICK = 'Notifications (Click)';
export const NOTIFICATIONS_COMPLETE = 'Notifications (Complete)';

export const SHOW_PAGE_MODAL_CLICK = 'Show_Modal-Open (Click)';
export const SHOW_PAGE_MODAL_CLOSE = 'Show_Modal-Close (Click)';
export const SHOW_PAGE_MODAL_NEXT_CLICK = 'Show_Modal-Next (Click)';
export const SHOW_PAGE_MODAL_PREVIOUS_CLICK = 'Show_Modal-Previous (Click)';

export const CANCELLATION_CLICK = 'Cancellation (Click)';
export const CANCELLATION_PAUSE_TRIGGERED = 'Cancellation-Pause (Triggered)';
export const CANCELLATION_PAUSE_COMPLETE = 'Cancellation-Pause (Complete)';
export const CANCELLATION_COMPLETE = 'Cancellation (Complete)';
export const CANCELLATION_DEAL_TRIGGERED = 'Cancellation-Deal (Triggered)';
export const CANCELLATION_DEAL_COMPLETE = 'Cancellation-Deal (Complete)';
export const CANCELLATION_DOWNGRADE_TRIGGERED = 'Cancellation-Downgrade (Triggered)';
export const CANCELLATION_DOWNGRADE_COMPLETE = 'Cancellation-Downgrade (Complete)';

export const MULTIPLE_LOGIN_TRIGGERED = 'Multiple Login (Triggered)';
export const MULTIPLE_LOGIN_COMPLETE = 'Multiple Login (Complete)';

export const REACTIVATION_BANNER_TRIGGERED = 'Reactivation-Banner (Triggered)';
export const REACTIVATION_BANNER_COMPLETE = 'Reactivation-Banner (Complete)';
export const REACTIVATION_POPUP_TRIGGERED = 'Reactivation-Popup (Triggered)';
export const REACTIVATION_POPUP_CLICK = 'Reactivation-Popup (Click)';
export const REACTIVATION_POPUP_ERROR = 'Reactivation-Popup (Error)';
export const REACTIVATION_POPUP_COMPLETE = 'Reactivation-Popup (Complete)';

export const REBUY_CLICK = 'Rebuy (Click)';
export const REBUY_UPGRADE_CLICK = 'Rebuy-Upgrade (Click)';
export const REBUY_UPGRADE_ERROR = 'Rebuy-Upgrade (Error)';
export const REBUY_UPGRADE_COMPLETE = 'Rebuy-Upgrade (Complete)';
export const REBUY_POPUP_CLICK = 'Rebuy-Popup (Click)';
export const REBUY_POPUP_ERROR = 'Rebuy-Popup (Error)';
export const REBUY_POPUP_COMPLETE = 'Rebuy-Popup (Complete)';

export const UPGRADE_BANNER_TRIGGERED = 'Upgrade-Banner (Triggered)';
export const UPGRADE_BANNER_COMPLETE = 'Upgrade-Banner (Complete)';
export const UPGRADE_POPUP_TRIGGERED = 'Upgrade-Popup (Triggered)';
export const UPGRADE_POPUP_CLICK = 'Upgrade-Popup (Click)';
export const UPGRADE_POPUP_ERROR = 'Upgrade-Popup (Error)';
export const UPGRADE_POPUP_REFUND_ERROR = 'Upgrade-Popup (Refund Error)';
export const UPGRADE_POPUP_COMPLETE = 'Upgrade-Popup (Complete)';

export const CANCEL_BUNDLES_TRIGGERED = 'Cancellation-Bundles (Triggered)';
export const CANCEL_BUNDLES_COMPLETE = 'Cancellation-Bundles (Complete)';
export const BUNDLES_TOAST_CLICK = 'Bundles-Toast (Click)';

export const CUSTOMER_FEEDBACK_TRIGGERED = 'Reviews (Triggered)';
export const CUSTOMER_FEEDBACK_POSITIVE = 'Reviews (Yes)';
export const CUSTOMER_FEEDBACK_NEGATIVE = 'Reviews (No)';

export const STUDIO_DEMO_CLICK = 'Book-Demo (Click)';

export const SEARCH_INFINITE_PAGE_TRIGGERED = 'Search-Infinite-Page (Triggered)';

export const EXPLORE_MENU_CLICK_BUNDLES = 'Menu-Bundles (Click)';
export const EXPLORE_MENU_CLICK_PHOTO = 'Menu-Photo (Click)';
export const EXPLORE_MENU_CLICK_VECTOR = 'Menu-Vector (Click)';
export const EXPLORE_MENU_CLICK_VIDEO = 'Menu-Video (Click)';

export const EDITOR_START_NEW_CLICK = 'Start New (Click)';
export const EDITOR_TEMPLATE_CLICK = 'Template (Click)';
export const EDITOR_HEADER_LINK_CLICK = 'Header-Templates (Click)';

export const CUSTOM_DESIGN_TRIGGERED = 'Custom_Design (Triggered)';
export const CUSTOM_DESIGN_CHECKBOX_CLICK = 'Custom_Design-Checkbox (Click)';
export const CUSTOM_DESIGN_COMPLETE = 'Custom_Design (Complete)';

export const TRIAL_CANCEL_CLICK = 'Trial-Cancel (Click)';
export const TRIAL_CANCEL_COMPLETE = 'Trial-Cancel (Complete)';

export const SEARCH_BY_IMAGE_CLICK = 'Search-Image (Click)';
export const SEARCH_BY_IMAGE_COMPLETE = 'Search-Image (Complete)';
export const SEARCH_BY_IMAGE_ERROR = 'Search-Image (Error)';

export const HOMEPAGE_BANNER_TRIGGERED = 'Homepage_Banner (Triggered)';
export const HOMEPAGE_BANNER_COMPLETE = 'Homepage_Banner (Complete)';

export type TrackingAction = |
  typeof GTM_DATALAYER |
  typeof PAGE_VIEW |
  typeof JOIN_TRIGGERED |
  typeof JOIN_CLICK |
  typeof JOIN_COMPLETE |
  typeof LOGIN_TRIGGERED |
  typeof LOGIN_CLICK |
  typeof LOGIN_COMPLETE |
  typeof SEARCH_MANUAL |
  typeof SEARCH_AUTOSUGGEST |
  typeof SEARCH_COMPLETE |
  typeof EC_BEGIN_CHECKOUT |
  typeof EC_PURCHASE_COMPLETE |
  typeof EC_PLAN_SELECTION |
  typeof EC_VIEW_PLANS |
  typeof EXPLORE_CLICK |
  typeof TRENDING_CLICK |
  typeof KEYWORD_CLICK |
  typeof LOCALE_TRIGGERED |
  typeof LOCALE_CLICK |
  typeof LOCALE_COMPLETE |
  typeof SOCIAL_SHARE_CLICK |
  typeof ZOOM_CLICK |
  typeof FAVORITE_CLICK |
  typeof EDITOR_CLICK |
  typeof JOIN_PRO_TRIGGERED |
  typeof JOIN_PRO_CLICK |
  typeof JOIN_PRO_COMPLETE |
  typeof TRIAL_UPGRADE_TRIGGERED |
  typeof TRIAL_UPGRADE_CLICK |
  typeof TRIAL_UPGRADE_COMPLETE |
  typeof POPULAR_SEARCHES_CLICK |
  typeof LICENSING_CLICK |
  typeof LICENSING_TRIGGERED |
  typeof LICENSING_COMPLETE |
  typeof CONTRIBUTOR_CLICK |
  typeof CONTRIBUTOR_FOLLOW |
  typeof CONTENT_SELECTION_CLICK |
  typeof DOWNLOAD_CLICK |
  typeof DOWNLOAD_COMPLETE |
  typeof FILTERS_HIDE_CLICK |
  typeof FILTERS_APPLIED_CLICK |
  typeof PAGINATION_CLICK |
  typeof COLLECTION_SAVE_CLICK |
  typeof COLLECTION_SAVE_COMPLETE |
  typeof COLLECTION_REMOVE_CLICK |
  typeof COLLECTION_REMOVE_COMPLETE |
  typeof COLLECTION_CREATED_COMPLETE |
  typeof COLLECTION_DELETED_COMPLETE |
  typeof FORM_FIELD_FOCUS |
  typeof FORM_COMPLETE |
  typeof FORM_ERROR |
  typeof PARTNER_INFINITE_SCROLL_TRIGGERED |
  typeof PARTNER_INFINITE_SCROLL_CLICK |
  typeof PARTNER_GRAY_BOX_TRIGGERED |
  typeof PARTNER_GRAY_BOX_CLICK |
  typeof PARTNER_POPUP_TRIGGERED |
  typeof PURCHASE_CLICK |
  typeof PURCHASE_COMPLETE |
  typeof PURCHASE_ERROR |
  typeof JOIN_LOGIN_TRIGGERED |
  typeof NOTIFICATIONS_CLICK |
  typeof NOTIFICATIONS_COMPLETE |
  typeof SHOW_PAGE_MODAL_CLICK |
  typeof SHOW_PAGE_MODAL_CLOSE |
  typeof SHOW_PAGE_MODAL_NEXT_CLICK |
  typeof SHOW_PAGE_MODAL_PREVIOUS_CLICK |
  typeof CANCELLATION_CLICK |
  typeof CANCELLATION_COMPLETE |
  typeof CANCELLATION_PAUSE_TRIGGERED |
  typeof CANCELLATION_PAUSE_COMPLETE |
  typeof CANCELLATION_DEAL_COMPLETE |
  typeof CANCELLATION_DEAL_TRIGGERED |
  typeof CANCELLATION_DOWNGRADE_TRIGGERED |
  typeof CANCELLATION_DOWNGRADE_COMPLETE |
  typeof MULTIPLE_LOGIN_TRIGGERED |
  typeof MULTIPLE_LOGIN_COMPLETE |
  typeof REACTIVATION_BANNER_TRIGGERED |
  typeof REACTIVATION_BANNER_COMPLETE |
  typeof REACTIVATION_POPUP_TRIGGERED |
  typeof REACTIVATION_POPUP_CLICK |
  typeof REACTIVATION_POPUP_ERROR |
  typeof REACTIVATION_POPUP_COMPLETE |
  typeof REBUY_CLICK |
  typeof REBUY_UPGRADE_CLICK |
  typeof REBUY_UPGRADE_ERROR |
  typeof REBUY_UPGRADE_COMPLETE |
  typeof REBUY_POPUP_CLICK |
  typeof REBUY_POPUP_ERROR |
  typeof REBUY_POPUP_COMPLETE |
  typeof UPGRADE_BANNER_TRIGGERED |
  typeof UPGRADE_BANNER_COMPLETE |
  typeof UPGRADE_POPUP_TRIGGERED |
  typeof UPGRADE_POPUP_CLICK |
  typeof UPGRADE_POPUP_ERROR |
  typeof UPGRADE_POPUP_REFUND_ERROR |
  typeof UPGRADE_POPUP_COMPLETE |
  typeof CANCEL_BUNDLES_TRIGGERED |
  typeof CANCEL_BUNDLES_COMPLETE |
  typeof BUNDLES_TOAST_CLICK |
  typeof CUSTOMER_FEEDBACK_TRIGGERED |
  typeof CUSTOMER_FEEDBACK_POSITIVE |
  typeof CUSTOMER_FEEDBACK_NEGATIVE |
  typeof STUDIO_DEMO_CLICK |
  typeof SEARCH_INFINITE_PAGE_TRIGGERED |
  typeof EXPLORE_MENU_CLICK_BUNDLES |
  typeof EXPLORE_MENU_CLICK_PHOTO |
  typeof EXPLORE_MENU_CLICK_VECTOR |
  typeof EXPLORE_MENU_CLICK_VIDEO |
  typeof EDITOR_START_NEW_CLICK |
  typeof EDITOR_TEMPLATE_CLICK |
  typeof EDITOR_HEADER_LINK_CLICK |
  typeof TRIAL_CANCEL_CLICK |
  typeof TRIAL_CANCEL_COMPLETE |
  typeof SEARCH_BY_IMAGE_CLICK |
  typeof SEARCH_BY_IMAGE_COMPLETE |
  typeof SEARCH_BY_IMAGE_ERROR |
  typeof HOMEPAGE_BANNER_TRIGGERED |
  typeof HOMEPAGE_BANNER_COMPLETE
